import { type ClassValue, clsx } from "clsx";
import { useEffect } from "react";
import { twMerge } from "tailwind-merge";

/**
 * Combine multiple header objects into one (uses append so headers are not overridden)
 */
export function combineHeaders(...headers: Array<ResponseInit["headers"] | null | undefined>) {
    const combined = new Headers();
    for (const header of headers) {
        if (!header) continue;
        for (const [key, value] of new Headers(header).entries()) {
            combined.append(key, value);
        }
    }
    return combined;
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export enum TTL {
    ONE_MINUTE = 60,
    TEN_MINUTES = 600,
    ONE_HOUR = 3600,
    ONE_DAY = 86400,
}

export type RequireVariantProps<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export function getAuthUrls({ returnTo }: { returnTo?: string } = {}) {
    const baseLoginPath = "/auth/login?";
    const params = new URLSearchParams();
    if (returnTo) {
        params.set("returnTo", returnTo);
    }
    const loginPath = `${baseLoginPath}${params.toString()}`;
    params.set("screen_hint", "signup");
    const signUpPath = `${baseLoginPath}${params.toString()}`;

    return {
        login: loginPath,
        signUp: signUpPath,
        logout: "/auth/logout",
    };
}

export const IMG_SAVED_SCROLL_POSITION = "scrollPosition";

export function captureScrollPosition() {
    const scrollPosition = window.scrollY;
    localStorage.setItem(IMG_SAVED_SCROLL_POSITION, scrollPosition.toString());
}

export function useSavedScollPosition() {
    useEffect(() => {
        const savedScrollPosition = localStorage.getItem(IMG_SAVED_SCROLL_POSITION);

        if (savedScrollPosition) {
            window.scrollTo(0, parseInt(savedScrollPosition, 10));
            localStorage.removeItem(IMG_SAVED_SCROLL_POSITION);
        }
    }, []);
}

// TODO: Move this to tests / fixtures eventually
export const MOCK_ATHLETE_ID = "2034595d-551f-45f1-a1d6-df540c33341b";
export const MOCK_ATHLETE_SPORT_ID = "4007";
export const MOCK_SPORT = "baseball";
export const MOCK_SELECTED_POSITION = {
    name: "Right Handed Hitter",
    id: "12884910279",
    ref: "positions/12884910279",
} as const;
